import { Layout as AntLayout, Menu } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  DashboardOutlined,
  LinkOutlined,
  UserOutlined,
  FileZipOutlined,
  SettingOutlined,
  LogoutOutlined,
  MonitorOutlined,
} from '@ant-design/icons';
import { useAuthStore } from '../stores/auth';
import styles from './Layout.module.css';

const { Header, Sider, Content } = AntLayout;

const menuItems = [
  { key: '/s/dashboard', icon: <DashboardOutlined />, label: '仪表盘' },
  { key: '/s/links', icon: <LinkOutlined />, label: '短链管理' },
  { key: '/s/users', icon: <UserOutlined />, label: '用户管理' },
  { key: '/s/archives', icon: <FileZipOutlined />, label: '日志归档' },
  { key: '/s/settings', icon: <SettingOutlined />, label: '系统设置' },
  { key: '/s/monitor', icon: <MonitorOutlined />, label: '系统监控' },
];

export default function Layout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuthStore();

  const handleMenuClick = ({ key }: { key: string }) => {
    navigate(key);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <AntLayout className={styles.layout}>
      <Sider width={200} className={styles.sider}>
        <div className={styles.logo}>SF Jump</div>
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={handleMenuClick}
          className={styles.menu}
        />
      </Sider>
      <AntLayout>
        <Header className={styles.header}>
          <div className={styles.userInfo}>
            <span>{user?.username}</span>
            <LogoutOutlined onClick={handleLogout} className={styles.logoutIcon} />
          </div>
        </Header>
        <Content className={styles.content}>
          <Outlet />
        </Content>
      </AntLayout>
    </AntLayout>
  );
}
